import { I18n } from '@calendly/i18n'
import { CalendarIcon } from '@calendly/ui/components/icons'
import { BodyText } from '@calendly/ui/components/typography'
import { colorIconSecondary, colorTextSecondary } from '@calendly/ui/theme'

import { TrimmedSubheader } from '../../components/styles'

export const Summary = () => (
  <BodyText color={colorTextSecondary} size="medium">
    <CalendarIcon size="standard" color={colorIconSecondary} spacingRight="8" />
    <TrimmedSubheader>
      {I18n.t('publisher.event_type_editor.sections.more_options.free_busy_rules.helper_text')}
    </TrimmedSubheader>
  </BodyText>
)
